import { render } from "./pathes.vue?vue&type=template&id=31b19cac&lang=pug"
import script from "./pathes.vue?vue&type=script&lang=js"
export * from "./pathes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/json/Code/chekt/app/fty/hosting/console/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__